import { render } from "./customManage.vue?vue&type=template&id=f2754858"
import script from "./customManage.vue?vue&type=script&lang=js"
export * from "./customManage.vue?vue&type=script&lang=js"

import "./customManage.vue?vue&type=style&index=0&id=f2754858&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__